document.addEventListener("DOMContentLoaded", function () {
  // setTimeout(() => {
  //   document.querySelector(
  //     ".purchase-details__buttons .action_button.add_to_cart span"
  //   ).innerHTML = "Add to cart";
  // }, 300);

  function fixAddToCartLabel() {
    const btn = document.querySelector(".purchase-details__buttons .action_button.add_to_cart span");
    if (btn && (!btn.innerHTML || btn.innerHTML.trim() === "")) {
      btn.innerHTML = "Add to cart";
    }
  }

  // Run once at load
  fixAddToCartLabel();

  // Watch DOM changes
  const observer = new MutationObserver(() => fixAddToCartLabel());
  observer.observe(document.body, { childList: true, subtree: true });

  
  const openBtn = document.getElementById("customize-disc-btn");
  const modal = document.getElementById("custom-modal-overlay");
  const closeBtn1 = document.getElementById("custom-close-btn");
  const closeBtn2 = document.getElementById("custom-close-btn-2");

  const loadMoreDesignBtn = document.getElementById("loadMoreDesignBtn");
  const buttonText = document.querySelector(".loadMoreDesignBtn .button-text");
  const buttonSpinner = document.querySelector(
    ".loadMoreDesignBtn .button-spinner"
  );

  const DGSAppBaseUrl =
    "https://discgolfswag.com/apps/dgsswagproxydMcghYu9ODsdsDDae";

  window.DGSAppBaseUrl = DGSAppBaseUrl;

  let limit = 12;
  let pageNumber = 1;
  let loadedPageNumber = 0;

  async function getJSONFileContent(url) {
    try {
      const response = await fetch(url);
      
      if (!response.ok) {
        throw new Error('Network response was not ok: ' + response.statusText);
      }

      const fileContent = await response.json();     
      return {status:true,fileContent};
      // return fileContent; // optionally return it if needed
    } catch (error) {
      // console.error('Error fetching JSON:', error);
      return {status:false,message:error.message || "failed to get file content",error};
    }
  }


  /**
   * Fetch paginated disc designs from backend
   * @param {number} page - Current page number (default: 1)
   * @param {number} limit - Number of items per page (default: 10)
   * @returns {Promise<object>} Response with designs and pagination info
   */
  async function fetchDesigns(loadMore = false) {
    if (loadMore === true) {
      pageNumber = pageNumber + 1;
    }
    if (loadedPageNumber >= pageNumber) {
      return false;
    }

    let offset = (pageNumber - 1) * limit;
    try {
      const container = document.querySelector(
        ".load-custom-disc-preview-container"
      );
      if (!window.ShopifyCustomerEmail) {
        container.innerHTML = `<p class="w-[100%] rounded-md mt-5 p-5 bg-yellow-200 text-red-700">
                  You are not logged in. Please <a href="${window.ShopifyLoginUrl}" class="font-bold">Login</a> to view the saved designs. </p>`;
        return false;
      }
      let body = JSON.stringify({ email: window.ShopifyCustomerEmail });
      const response = await fetch(
        `${DGSAppBaseUrl}/disc-designs/get-designs?page=${pageNumber}&limit=${limit}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
          method: "POST",
          body,
        }
      );

      if (!response.ok) {
        console.error(`Server responded with status ${response.status}`);
        return false;
      }

      const data = await response.json();
      if (!data.status) {
        console.error(data.message || "Failed to fetch designs");
        return false;
      }
      let { designs, pagination,publicS3BaseUrl } = data.data;
      

      let { hasMore } = pagination;
      

      let previousDesigns = window.previousDesigns;

      if (designs.length > 0) {
        let previousDesigns_ = await Promise.all(designs.map(async(value) => {
            let { id, imagePath, designData ,imageFileName,jsonFileName} = value;
            let { origin } = window.location;
            // let imageUrl = origin + "/" + imagePath;            

            // S3 work
            let imageUrl = publicS3BaseUrl + "/" + imageFileName;  
            let jsonFileUrl = publicS3BaseUrl + "/" + jsonFileName;  
            let jsonFileContentResult = await getJSONFileContent(jsonFileUrl)
            if(jsonFileContentResult.status===true){
                fileContent = jsonFileContentResult.fileContent
                return { id, src: imageUrl, json: JSON.parse(fileContent) };
            }else{
              return null
            } 
            // return { id, src: imageUrl, json: JSON.parse(designData) };           
          })
        );

        // clean the list
        previousDesigns_ = previousDesigns_.filter(value=> value !== null);     

       if (pageNumber === 1) {
        container.innerHTML = ``; // clear container only on first page
        previousDesigns = [...previousDesigns_];
      } else {
        previousDesigns = [...previousDesigns, ...previousDesigns_]; // append new ones
      }


        if (hasMore === true) {
          loadMoreDesignBtn.classList.remove("!hidden");
        } else {
          loadMoreDesignBtn.classList.add("!hidden");
        }
      } else if (designs.length === 0 && pageNumber === 1) {
        // hide the loader

        container.innerHTML = `<div class="text-center text-black text-md mt-10">
         No Previous Designs are found!
        </div>`; // Clear existing content
      }

      if (previousDesigns.length > 0) {
        window.previousDesigns = previousDesigns;
        window.loadPreviousDesign(previousDesigns);
      }

      loadMoreDesignBtn ? (loadMoreDesignBtn.disabled = false) : "";
      buttonText.classList.remove("hidden");
      buttonSpinner.classList.add("hidden");

      loadedPageNumber = pageNumber;

      return data.data; // { designs, pagination }
    } catch (error) {
      console.error("❌ Error fetching designs:", error.message);
      return false;
    }
  }



  loadMoreDesignBtn?.addEventListener("click", async function () {
    // Disable the button and show the spinner
    loadMoreDesignBtn.disabled = true;
    buttonText.classList.add("hidden");
    buttonSpinner.classList.remove("hidden");
    const loadMore = true;

    await fetchDesigns(loadMore);
  });

  function resetAndRefethDesigns() {
    limit = 10;
    pageNumber = 1;
    loadedPageNumber = 0;
    const container = document.querySelector(
      ".load-custom-disc-preview-container"
    );
    container.innerHTML = `<div
        id="custom-loader"
       class="flex items-center justify-center bg-white my-10 w-[100%] custom-loader"
      >
      <div
        class="animate-spin rounded-full w-20 h-20 border-8 border-slate-300 border-t-transparent"
      ></div>
    </div>`; // Clear existing content
    window.previousDesigns = [];
    fetchDesigns();
  }
  window.resetAndRefethDesigns = resetAndRefethDesigns;

  function openModal() {
    fetchDesigns();
    modal.style.display = "block";
    document.body.style.overflow = "hidden"; // Lock background scroll
    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    }, 500);
  }

  function closeModal() {
    modal.style.display = "none";
    document.body.style.overflow = ""; // Re-enable scroll
  }
  window.closeModal = closeModal;

  openBtn?.addEventListener("click", openModal);
  closeBtn1?.addEventListener("click", closeModal);
  closeBtn2?.addEventListener("click", closeModal);

  // Optional: Close on ESC key
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeModal();
  });

  // Optional: Click outside modal to close
  window.addEventListener("click", function (e) {
    if (e.target === modal) closeModal();
  });

  // JS for tabs
  const tabs = document.querySelectorAll(".custom-tabs-nav li");
  const contents = document.querySelectorAll(".custom-tab-content");

  tabs.forEach((tab) => {
    tab.addEventListener("click", function () {
      // Remove active class from all tabs & contents
      tabs.forEach((t) => t.classList.remove("active"));
      contents.forEach((c) => c.classList.remove("active"));

      // Add active to selected
      this.classList.add("active");
      const tabId = this.getAttribute("data-tab");
      document.getElementById(tabId).classList.add("active");
    });
  });

  function activeGivenTab(tabId) {
    // Remove "active" class from all tabs and contents
    tabs.forEach((t) => t.classList.remove("active"));
    contents.forEach((c) => c.classList.remove("active"));

    // Add "active" class to the tab with the given tabId
    const activeTab = document.querySelector(`[data-tab="${tabId}"]`);
    const activeContent = document.getElementById(tabId);

    if (activeTab && activeContent) {
      activeTab.classList.add("active");
      activeContent.classList.add("active");
    }
  }
  window.activeGivenTab = activeGivenTab;

  function getActiveTabId() {
    const activeTab = document.querySelector(".custom-tabs-nav li.active");
    return activeTab ? activeTab.getAttribute("data-tab") : null;
  }
  window.getActiveTabId = getActiveTabId;
  
  function generateUniqueId() {
    return "id-" + Date.now() + "-" + Math.floor(Math.random() * 1000000);
  }
  window.generateUniqueId = generateUniqueId;

  let latestValidationId = 0;
  let debounceTimer;

  // Add to cart btns for design link tab
  let designLinkProductQuantityHtmlWrapper = document.querySelector(".design_link_product_quantity_html_wrapper");
  let designLinkAddToCartBtn = document.querySelector(".designLinkAddToCartBtn");


  function isValidImage(url) {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => resolve(true);
      img.onerror = () => resolve(false);
      img.src = url;
    });
  }
  // validation for link input
  const handleAddLinkChange = (e) => {
    clearTimeout(debounceTimer);

    debounceTimer = setTimeout(async () => {
      const currentValidationId = ++latestValidationId;

      const btn = document.getElementById("add-link-form-btn");
      const error = document.getElementById("design-link-error");
      btn.classList.add("dics-disabled");
      error.classList.add("opacity-0");

      const value = e.target.value.trim();
      if (!value) return;

      const valid = await isValidImage(value);

      // Only apply the result of the latest validation
      if (currentValidationId !== latestValidationId) return;

      if (!valid) {
        btn.classList.add("dics-disabled");
        error.classList.remove("opacity-0");

        designLinkProductQuantityHtmlWrapper.classList.add("dics-disabled")
        designLinkAddToCartBtn.classList.add("dics-disabled")


      } else {
        btn.classList.remove("dics-disabled");
        error.classList.add("opacity-0");

        designLinkProductQuantityHtmlWrapper.classList.remove("dics-disabled")
        designLinkAddToCartBtn.classList.remove("dics-disabled")
      }
    }, 300); // Debounce: 300ms
  };

  let designLinkBtn = document.getElementById("design-link");
  
  // validation for link input
  designLinkBtn.addEventListener("paste", handleAddLinkChange);
  designLinkBtn.addEventListener("change", handleAddLinkChange);
  designLinkBtn.addEventListener("keyup", handleAddLinkChange);

  // link form submission
  const handleLinkSubmission = async()=>{
    const link = document.getElementById("design-link").value;

    document.getElementById("disc-design-data-url-type").value = "External";
    document.getElementById("disc-design-data-url").value = link;

    // Show the image preview btn
    document
      .getElementById("view-dics-design-preview-link")
      .classList.remove("hidden");

    closeModal();
  }
  document
    .getElementById("add-link-form-btn")
    .addEventListener("click", async function (e) {
      e.preventDefault();
      await handleLinkSubmission()
      return false;
    });
    designLinkAddToCartBtn.addEventListener("click",async function(){
      const modalCartWrapper = this.closest(".modal-cart-wrapper");
      const productQuantity = modalCartWrapper.querySelector(".modal-product-quantity").value;        
      document.querySelector("input.product-qunatity[name='quantity']").value = productQuantity;

      this.classList.add("opacity-50", "cursor-not-allowed");
      await handleLinkSubmission()
      this.closest(".atc-btn-container")
      .querySelector(".add_to_cart")
      .click();
      window.setTimeout(()=>{
        this.classList.remove("opacity-50", "cursor-not-allowed");
      },2500)
    })
});
